import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CapabilitiesService {
  constructor(private http: HttpClient) {}

  getCapabilities(body:any) {
    return this.http.post('/capabilities/list', body);
  }

  getModules() {
    return this.http.get('/capabilities/modules');
  }

  saveCapabilities(body:any) {
    return this.http.post('/capabilities', body);
  }

  deleteCapabilities(data:any) {
    return this.http.post('/capabilities/remove', data);
  }
}
